import commonApi from '@/api/api.common'
import i18n from '@/locales/index'
export default [
  {
    type: 'input',
    placeholder: i18n.t('Product.serialName'),
    filed: 'name',
    default: ''
  },
  {
    type: 'input',
    placeholder: i18n.t('Product.serialCode'),
    filed: 'code',
    default: ''
  },
  {
    type: 'select',
    placeholder: i18n.t('Product.category'),
    filed: 'category',
    default: '',
    query: commonApi.product_type_select
  }
]
